import { render, staticRenderFns } from "./BookingFood.vue?vue&type=template&id=778b331a&scoped=true&"
import script from "./BookingFood.vue?vue&type=script&lang=js&"
export * from "./BookingFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b331a",
  null
  
)

export default component.exports